import DeviceFilesList from './deviceFilesList/deviceFilesList';
import DeviceTags from './deviceTags/deviceTags';
import BatteryLevel from './batteryLevel/batteryLevel';
import NetworkConnection from './networkConnection/networkConnection';
import radarSchema from './radarSchema/radarSchema';

export default angular
  .module('main.devices.edit.components', [
    DeviceFilesList,
    DeviceTags,
    BatteryLevel,
    NetworkConnection,
    radarSchema,
  ])
  .name;
